import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

// Pagination component
// Allows creating client-side pagination to display a list.
//
// Props:
//  itemsCount (Number, required) - Total number of items in the list.
//  pageSize (Number, required) - Size of each page (number of elements in each page).
//  currentPage (Number, required) - The current page number to show as active (other page numbers are shown as inactive).
//  onPageChange (function, required) - A method to be called in the parent component when a page number is clicked (to change the page).
//
const Pagination = (props) => {
  const { itemsCount, pageSize, currentPage, onPageChange } = props;
  const pageCount = Math.ceil(itemsCount / pageSize);
  if (pageCount === 1) return null; // If there is only one page, then no need to show pagination control
  const pages = _.range(1, pageCount + 1);

  return (
    <nav>
      <ul className="pagination justify-content-end">
        {pages.map((page) => (
          <li
            key={page}
            className={page === currentPage ? "page-item active" : "page-item"}
          >
            <button
              className="page-link"
              style={buttonStyle}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

Pagination.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

const buttonStyle = {
  outline: "none",
  boxShadow: "none",
};

export default Pagination;
